import { FC } from 'react'

import { TextareaInput } from 'ui/components/InputV2'
import { Select } from 'ui/components/Select'
import { Col, Col2x, FormRow } from 'ui/themes/globalStyles'

import { SecondText } from '../../style'
import { Props } from './Props'

export const ReviewCreditCardActivityForInternationalWasThere: FC<Props> = ({ Field }) => (
  <>
    <FormRow>
      <Col2x>
        <SecondText>
          Review the credit card activity for international transactions and unknown merchant/vendor activity.
        </SecondText>
      </Col2x>
    </FormRow>
    <FormRow>
      <Col>
        <Field
          name="reviewCreditCardActivityForInternationalWasThere"
          label="Was there international or unknown merchant/vendor activity?"
          input={Select}
          inputProps={{
            data: [
              {
                label: 'Yes – See comments',
                value: 'yes'
              },
              {
                label: 'All Transactions Ok',
                value: 'all_transactions'
              },
              {
                label: 'No Transactions of This Type',
                value: 'no_transactions'
              }
            ]
          }}
        />
      </Col>
    </FormRow>
    <FormRow>
      <Col>
        <Field
          name="reviewCreditCardActivityForInternationalActivityAddressed"
          label="If noted, how was the activity addressed?"
          input={Select}
          inputProps={{
            data: [
              {
                label: 'N/A',
                value: 'n/a'
              },
              {
                label: 'Transaction cleared with communication to customer during review',
                value: 'cleared'
              },
              {
                label: 'Transaction added to annual questions',
                value: 'added'
              }
            ]
          }}
        />
      </Col>
    </FormRow>
    <FormRow>
      <Col2x>
        <Field
          name="reviewCreditCardActivityForInternationalComments"
          label="Comments"
          input={TextareaInput}
          inputProps={{
            maxLength: 5000
          }}
        />
      </Col2x>
    </FormRow>
  </>
)
